import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardMedia,
    Grid,
    IconButton,
    InputAdornment,
    Stack,
    Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import tc from "../../assests/img/Transaction-Certificate.svg";
import sc from "../../assests/img/Scope-Certificate.svg";
import ml from "../../assests/img/Material-Ledger.svg";
import iu from "../../assests/img/Inventory-Update.svg";
import mdfrmdf from "../../assests/img/MDF-RMDF.svg";
import rms from "../../assests/img/Raw-Material-Summary.svg";
import { useState, useEffect } from "react";
import { CustomTextField } from "../../shared/components/inputfields/form-elements";
import SearchIcon from "@mui/icons-material/Search";
import { ReactComponent as Loader } from "../../assests/logos/loader.svg";
import Logo from "../../assests/logos/Trackit.svg";
import CustomCard from "../../shared/components/cards/cards";
import { useTransactionCertificateStore } from "../../store/transaction-certificates.store";
import { extractTEIdFromEmail } from "../../shared/utils/user-utils";
import VersionSelectorPopup from "./versionSelector";
// import atcLogo from "../../assests/img/ATC-Logo.svg";
import { AppConfig } from "../../shared/app-configs/app-config";
import { useNavigate } from "react-router-dom";

const MainHomePage = () => {
    const [showModal,setShowModal] = useState<boolean>(false);
    const [source,setSource] = useState<string>("tc");
    const [currentView, setCurrentView] = useState<'main' | 'ml-sub'>('main');
    const { getUserInfo, cbLicensingCode } = useTransactionCertificateStore();
    const navigate = useNavigate();
    
    // State to track if user is a CO (Certified Organization)
    const [isCOUser, setIsCOUser] = useState(false);

    let mainMenus = [
        {
            id: 1,
            source: tc,
            textContent: "Transaction Certificate",
            disabled: false,
            disableNav: false,
            path: "/tc-dashboard",
            color: "#C1C4CC",
        },
        {
            id: 2,
            source: sc,
            textContent: "Scope Certificate",
            disabled: false,
            disableNav: false,
            path: "/sc-dashboard",
            color: "#C1C4CC",
        },
        {
            id: 3,
            source: ml,
            textContent: "Material Ledger",
            disabled: false,
            hasSubMenu: true,
            path: "/ml/material-ledger",
            color: "#C1C4CC",
        }
    ];

    let mlSubMenus = [
        {
            id: 1,
            source: ml,
            textContent: "Material Ledger Summary",
            disabled: false,
            path: "/ml/material-ledger",
            color: "#C1C4CC",
        },
        {
            id: 2,
            source: rms,
            textContent: "Raw Material Summary",
            disabled: false,
            path: "/ml-form",
            color: "#C1C4CC",
        },
        {
            id: 3,
            source: iu,
            textContent: "Inventory Updates",
            disabled: false,
            path: "/ml/inventory-updates",
            color: "#C1C4CC",
        },
        // {
        //     id: 4,
        //     source: atcLogo,
        //     textContent: "Alternative TC",
        //     disabled: false,
        //     path: "/atc",
        //     color: "#C1C4CC",
        // }
    ];

    // CO User Detection
    useEffect(() => {
        const userEmail = cbLicensingCode;
        if (userEmail) {
            const extractedTEId = extractTEIdFromEmail(userEmail);
            setIsCOUser(!!extractedTEId);
        }
    }, [getUserInfo?.userEmail]);

    // Filter main menu items for CO users
    const allowedCOItems = [
        "Material Ledger",
        "Raw Material Summary",
        // "Alternative TC"
    ];

    const filteredMainMenus = isCOUser 
        ? mainMenus.filter(item => allowedCOItems.includes(item.textContent))
        : mainMenus;

    const filteredMLSubMenus = isCOUser 
        ? mlSubMenus.filter(item => allowedCOItems.includes(item.textContent))
        : mlSubMenus;

    // Get current menu based on view
    const getCurrentMenus = () => {
        return currentView === 'main' ? filteredMainMenus : filteredMLSubMenus;
    };

    const [filteredCards, setFilteredCards] = useState(getCurrentMenus());

    // Update filtered cards when view or CO user status changes
    useEffect(() => {
        setFilteredCards(getCurrentMenus());
    }, [currentView, isCOUser]);

    const onSearch = (value: string) => {
        const searchTerm = value.toLowerCase();
        const currentMenus = getCurrentMenus();
        const filtered = currentMenus.filter((card) =>
            card.textContent.toLowerCase().includes(searchTerm)
        );
        setFilteredCards(filtered);
    };

    const handleClick = (src: string) => {
        setSource(src);
        if (AppConfig.SHOW_VERSION_SELECTOR) {
            setShowModal(true);
        } else {
            // Navigate directly to v3 dashboard when modal is disabled
            const isScopeCertificate = src === "Scope Certificate";
            const defaultPath = isScopeCertificate ? '/sc-dashboard' : '/tc-dashboard';
            
            // Try React Router navigation first
            navigate(defaultPath, { replace: true });
            
            // Fallback: Force navigation using window.location
            setTimeout(() => {
                window.location.href = defaultPath;
            }, 100);
        }
    };

    const handleMaterialLedgerClick = () => {
        setCurrentView('ml-sub');
    };

    const handleBackClick = () => {
        setCurrentView('main');
    };
    return (
        <>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    padding: "2rem",
                }}
            >
                <Box
                    component="img"
                    src={Logo}
                    alt="Logo"
                    sx={{
                        width: "auto",
                        height: "5rem",
                    }}
                />
                {/* <Typography variant="h3" >Trackit P<Loader style={{ width: 20, height: 20 }} />rtal</Typography> */}
                {/* <Typography variant="h3" >Trackit Portal</Typography> */}

                {/* Search Bar */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                    }}
                >
                    <CustomTextField
                        label=""
                        onChange={(e) => onSearch(e.target.value)}
                        placeholder="Search"
                        sx={{
                            mb: 2,
                            width: "50%",
                            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                            borderRadius: 2,
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon color="disabled" />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>

                {/* Card Section */}
                <Card
                    sx={{
                        width: "90%", // Adjust the width for better responsiveness
                        maxWidth: 1200, // Limit the width for larger screens
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        mt: 2, // Add spacing between the search field and the card
                        p: "2rem", // Add padding to the card
                        boxShadow: 3, // Optional: Add some elevation
                        backgroundColor: "#FFFFFF",
                        borderRadius: "8px",
                    }}
                >
                    {/* Back Button - only show when in ML sub-view */}
                    {currentView === 'ml-sub' && (
                        <Box
                            sx={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "flex-start",
                                mb: 2,
                            }}
                        >
                            <Button
                                startIcon={<ArrowBackIcon />}
                                onClick={handleBackClick}
                                sx={{
                                    color: "#353C52",
                                    textTransform: "none",
                                    fontSize: "1rem",
                                    fontWeight: 500,
                                    "&:hover": {
                                        backgroundColor: "rgba(53, 60, 82, 0.04)",
                                    },
                                }}
                            >
                                Back to Main Menu
                            </Button>
                        </Box>
                    )}
                    <Grid
                        container
                        spacing={2} // Adds spacing between grid items
                        sx={{
                            direction: "ltl", // Align items starting from the right
                        }}
                        justifyContent="center"
                    >
                        {filteredCards.map((media, index) => (
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={4}
                                lg={2}
                                key={media.id}
                                sx={{
                                    display: "flex",
                                    justifyContent: "center", // Centers the grid item
                                }}
                            >
                                <Box
                                    sx={{
                                        transition: "transform 0.3s ease-in-out", // Smooth animation
                                        "&:hover": {
                                            transform: "scale(1.1)", // Scales the card slightly on hover
                                        },
                                    }}
                                >
                                    <CustomCard
                                        source={media.source}
                                        textContent={media.textContent}
                                        color={media.color}
                                        path={media.path}
                                        disabled={media.disabled}
                                        disableNav={
                                            currentView === 'main' && (
                                                media.textContent === 'Transaction Certificate' ||
                                                media.textContent === 'Scope Certificate' ||
                                                media.textContent === 'Material Ledger'
                                            )
                                        }
                                        onClick={() => {
                                            if (currentView === 'main' && media.textContent === 'Material Ledger') {
                                                handleMaterialLedgerClick();
                                                return;
                                            }
                                            if (currentView === 'main' && (media.textContent === 'Transaction Certificate' || media.textContent === 'Scope Certificate')) {
                                                handleClick(media.textContent);
                                            }
                                        }}
                                    />
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Card>
            </Box>
            {AppConfig.SHOW_VERSION_SELECTOR && (
                <VersionSelectorPopup
                    open={showModal}
                    onClose={() => setShowModal(false)}
                    source={source}
                    versionLinks={{
                        v3: source==="Scope Certificate"?'/sc-dashboard':"/tc-dashboard",
                        v4: source==="Scope Certificate"?'/v4/sc-dashboard':"/v4/tc-dashboard",
                    }}
                />
            )}
        </>

    );
};

export default MainHomePage;
